import {
  Building2,
  ClipboardCheck,
  FileCheck,
  FilePen,
  Leaf,
  ListFilter,
  Microscope,
  Sprout,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface AmbientalPipe {
  id: string;
  label: string;
  description: string;
  icon: LucideIcon;
  kind?: 'parent' | 'child';
}

export const AMBIENTAL_PIPES: AmbientalPipe[] = [
  {
    id: 'triagem_ambiental',
    label: 'Triagem Ambiental',
    description: 'Entrada comercial, orçamento e encaminhamento para o pipe técnico.',
    icon: ListFilter,
    kind: 'parent',
  },
  {
    id: 'ambiental_car',
    label: 'CAR',
    description: 'Cadastro Ambiental Rural — inscrição/retificação.',
    icon: Leaf,
    kind: 'child',
  },
  {
    id: 'ambiental_car_retificacao',
    label: 'Notificações para Retificação [CAR]',
    description: 'Rodadas de retificação vinculadas ao CAR principal.',
    icon: FilePen,
    kind: 'child',
  },
  {
    id: 'ambiental_pra',
    label: 'PRA',
    description: 'Programa de Regularização Ambiental.',
    icon: Sprout,
    kind: 'child',
  },
  {
    id: 'ambiental_desembargo',
    label: 'Desembargo',
    description: 'Desembargo de áreas autuadas.',
    icon: FileCheck,
    kind: 'child',
  },
  {
    id: 'ambiental_limpeza',
    label: 'Limpeza',
    description: 'Autorização para limpeza de área.',
    icon: ClipboardCheck,
    kind: 'child',
  },
  {
    id: 'ambiental_licenciamento',
    label: 'Licenciamento de Empreendimentos',
    description: 'Macroserviço com etapas LP, LI e LO.',
    icon: Building2,
    kind: 'child',
  },
  {
    id: 'ambiental_estudos_tecnicos',
    label: 'Laudos e Análises Técnicas',
    description: 'Macroserviço com laudo/parecer e análise multitemporal.',
    icon: Microscope,
    kind: 'child',
  },
];
